'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useState } from 'react';
import { useTranslation } from '@/hook';
import { ArrowDownGrey } from '../../../../public/Images';
import { IStepperItem_SELL_NEW, StepperStep } from '@/types';
import styles from './styles.module.scss';
import Image from 'next/image';

const StepperSteps = ({
  steps,
  open,
  goToStep,
  path,
}: {
  steps: IStepperItem_SELL_NEW[];
  open: boolean;
  goToStep: (step: StepperStep) => void;
  path: 'path1' | 'path2';
}) => {
  const { t, IS_RTL } = useTranslation();

  const checkConnectorActive = (key: StepperStep) => {
    const keyIndex = steps.findIndex((step) => step.label === key);
    if (keyIndex + 1 >= steps.length) return false;

    return steps[keyIndex].activated === true && steps[keyIndex + 1].activated === true;
  };

  const goToStepperStepBridge = (key: StepperStep) => {
    const step = steps.findIndex((stp) => stp.label === key);
    if (!steps[step].activated) return;
    goToStep(key);
  };
  const determineStepperItemColor = (step: IStepperItem_SELL_NEW) => {
    const bgColor = !step.showAlert ? '#F3FFFA' : '#FFFCF5';
    const borderColor = !step.showAlert ? '#99EBCB' : '#FEDF89';
    const valueColor = !step.showAlert ? '#009B5D' : '#DC6803';
    const itemTextColor = !step.showAlert ? '#00673E' : '#B54708';
    const connectorColor = !step.showAlert ? '#66E2B0' : '#FEC84B';
    return {
      bgColor,
      borderColor,
      valueColor,
      itemTextColor,
      connectorColor,
    };
  };

  return (
    <div className={styles.steps_container} steps-state={open ? 'open' : ''}>
      {steps.map(
        (stp, index) =>
          steps[index].allowed && (
            <button
              className={styles.stepper_step_container}
              style={
                steps[index].activated
                  ? {
                      backgroundColor: determineStepperItemColor(steps[index]).bgColor,
                      borderColor: determineStepperItemColor(steps[index]).borderColor,
                    }
                  : {}
              }
              onClick={() => goToStepperStepBridge(stp.label)}
              key={stp.label}
            >
              <div className={styles.stepper_step_item_container}>
                <Image alt={steps[index].label} width={20} height={20} src={steps[index].icon} />
                <Typography
                  color={determineStepperItemColor(steps[index]).itemTextColor}
                  variant="body2"
                >
                  {t(steps[index].label)}
                </Typography>
              </div>
              <div className={styles.stepper_step_item_container}>
                {steps[index]?.iconValue && (
                  <img
                    alt={steps[index].label}
                    width={20}
                    height={20}
                    src={steps[index]?.iconValue}
                  />
                )}
                <Typography
                  color={determineStepperItemColor(steps[index]).valueColor}
                  variant="body2SemiBold"
                >
                  {IS_RTL ? steps[index]?.valueAr : steps[index]?.value}
                </Typography>
              </div>
              {index < Object.keys(steps).length - 1 && (
                <div
                  className={styles.stepper_connector}
                  style={
                    checkConnectorActive(stp.label)
                      ? {
                          backgroundColor: determineStepperItemColor(steps[index]).connectorColor,
                        }
                      : {}
                  }
                />
              )}
            </button>
          ),
      )}
    </div>
  );
};
const StepperNavigator = ({
  label,
  step,
  icon,
  totalSteps,
  stepper,
  backgroundColor,
  mainIcon,
  goToSpecificStep,
  path,
}: {
  label: StepperStep;
  step: number;
  icon: string;
  totalSteps: number;
  stepper: IStepperItem_SELL_NEW[];
  backgroundColor: string;
  mainIcon: any;
  goToSpecificStep: (step: StepperStep) => void;
  path: 'path1' | 'path2';
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const returnStepperIndicatorProgress = () => {
    const progress = (step / totalSteps) * 100;
    return `${progress}%`;
  };
  const goToSpecificStepBridge = (step: StepperStep) => {
    setOpen(false);
    goToSpecificStep(step);
  };
  return (
    <div className={styles.stepper_header_container}>
      <div className={styles.stepper_navigator_container}>
        <div className={styles.stepper_navigator_icon} style={{ backgroundColor: backgroundColor }}>
          {mainIcon ? <Image src={mainIcon} width={20} height={20} alt={label} /> : null}
        </div>
        <button className={styles.step_navigation_button} onClick={() => setOpen(!open)}>
          <div
            className={styles.step_navigation_button}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Typography style={{ color: '#667085' }} variant="body2">
              {t('step')} {step}
            </Typography>
            <img
              style={{
                transform: open ? 'scale(-1)' : 'scale(1)',
              }}
              src={ArrowDownGrey.src}
              width={ArrowDownGrey.width}
              height={ArrowDownGrey.height}
              alt=""
            />
          </div>
          <Typography color="#344054" variant="body1Bold">
            {t(label)}
          </Typography>
        </button>
      </div>
      <div className={styles.stepper_progress_container}>
        <div
          className={styles.stepper_progress_indicator}
          style={{ width: returnStepperIndicatorProgress() }}
        />
      </div>
      <StepperSteps goToStep={goToSpecificStepBridge} open={open} steps={stepper} path={path} />
    </div>
  );
};

export default StepperNavigator;
